import { initContract } from '@ts-rest/core';
import { z } from 'zod';
const c = initContract();
export const AddDeviceVariantToCheckoutBodySchema = z.object({
    organizationId: z.string().min(1),
    deviceVariantId: z.string().min(1),
    quantity: z.number().int().positive(),
    siteId: z.string().min(1),
});
export const AddAccessoryToCheckoutBodySchema = z.object({
    organizationId: z.string().min(1),
    accessoryId: z.string().min(1),
    quantity: z.number().int().positive(),
    siteId: z.string().min(1),
    deviceVariantId: z.string().optional(),
    color: z.string().optional(),
});
const IsoDateSchema = z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'Expected a YYYY-MM-DD date');
/**
 * International eSIM from the catalog. The offer is re-quoted server-side
 * from the destination and the stay (never priced by the client); the
 * beneficiary is either a fleet line (its number and holder are snapshotted
 * server-side, the e-mail stays editable) or an outsider (name + e-mail).
 */
export const AddTravelEsimToCheckoutBodySchema = z
    .object({
    organizationId: z.string().min(1),
    country: z.string().min(1),
    siteId: z.string().min(1),
    departureDate: IsoDateSchema,
    returnDate: IsoDateSchema,
    beneficiary: z.discriminatedUnion('kind', [
        z.object({
            kind: z.literal('LINE'),
            lineId: z.string().min(1),
            email: z.string().email(),
        }),
        z.object({
            kind: z.literal('EXTERNAL'),
            name: z.string().trim().min(1),
            email: z.string().email(),
        }),
    ]),
    /** Recharge this eSIM of the beneficiary (must belong to them). */
    travelEsimId: z.string().min(1).nullish(),
    /** Create a new eSIM even if the beneficiary already has one. */
    newEsim: z.boolean().optional(),
})
    .refine((b) => b.returnDate >= b.departureDate, {
    message: 'returnDate must be on or after departureDate',
});
export const catalogCheckoutContract = c.router({
    addTravelEsimToCheckout: {
        method: 'POST',
        path: '/catalog-checkout/add-travel-esim',
        body: AddTravelEsimToCheckoutBodySchema,
        responses: { 201: z.object({ success: z.boolean() }) },
        summary: 'Add an international eSIM to the draft checkout',
    },
    addDeviceVariantToCheckout: {
        method: 'POST',
        path: '/catalog-checkout/add-device-variant',
        body: AddDeviceVariantToCheckoutBodySchema,
        responses: {
            201: z.object({ success: z.boolean() }),
        },
        summary: 'Add a device variant to the checkout',
    },
    addAccessoryToCheckout: {
        method: 'POST',
        path: '/catalog-checkout/add-accessory',
        body: AddAccessoryToCheckoutBodySchema,
        responses: {
            201: z.object({ success: z.boolean() }),
        },
        summary: 'Add an accessory to the checkout',
    },
});
